export default {"src":"/uk/_next/static/media/spot-money-balancing.a0e17f13.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};